<template>
    <div>
  
  
    <router-link v-if="item.type == 'shop'" :to="{ name: 'shop.product.show', 'params' : {'id' : item.shop_product.id} }" @click.native="this.$emit('hideCart', type)" class="dropdown-item cart_header_item">
    <div class="cart_header_item_photo">
    <img :src="item.shop_product.poster">
    </div>
    <div class="cart_header_item_np">
    <div class="cart_header_item_name">{{ item.shop_product.title }}</div>
    <div class="cart_header_item_price" v-if="item.shop_price != null">{{ item.shop_price.price }} руб.</div>
    <div class="cart_header_item_price" v-else>Не указана</div>
    <div class="quantity">
        <b-input-group>
          <b-input-group-prepend>
            <b-btn variant="info" @click.prevent="decrement(index, item.id)">-</b-btn>
          </b-input-group-prepend>
    
          <b-form-input type="number" min="0.00" :value="item.count"></b-form-input>
    
          <b-input-group-append>
            <b-btn variant="info" @click.prevent="increment(index, item.id)">+</b-btn>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <div class="cart_header_item_delete" @click.prevent="removeCart(index, item.id)">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.8499 9.13989L18.1999 19.2099C18.0899 20.7799 17.9999 21.9999 15.2099 21.9999H8.7899C5.9999 21.9999 5.9099 20.7799 5.7999 19.2099L5.1499 9.13989" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.3301 16.5H13.6601" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 12.5H14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div>
    </router-link>

    <router-link v-if="item.type == 'market'" :to="{ name: 'market.product.show', 'params' : {'id' : item.product.id} }" @click.native="this.$emit('hideCart', type)" class="dropdown-item cart_header_item">
    <div class="cart_header_item_photo">
    <img :src="item.product.poster">
    </div>
    <div class="cart_header_item_np">
    <div class="cart_header_item_name">{{ item.product.title }}</div>
    <div class="cart_header_item_price" v-if="item.market_price != null">{{ item.market_price.price }} руб.</div>
    <div class="cart_header_item_price" v-else>Не указана</div>
    <div class="quantity">
        <b-input-group>
          <b-input-group-prepend>
            <b-btn variant="info" @click.prevent="decrement(index, item.id)">-</b-btn>
          </b-input-group-prepend>
    
          <b-form-input type="number" min="0.00" :value="item.count"></b-form-input>
    
          <b-input-group-append>
            <b-btn variant="info" @click.prevent="increment(index, item.id)">+</b-btn>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <div class="cart_header_item_delete" @click.prevent="removeCart(index, item.id)">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.8499 9.13989L18.1999 19.2099C18.0899 20.7799 17.9999 21.9999 15.2099 21.9999H8.7899C5.9999 21.9999 5.9099 20.7799 5.7999 19.2099L5.1499 9.13989" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.3301 16.5H13.6601" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 12.5H14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div>
    </router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Cart_item',
    data(){
      return {
        checktype: this.item.type,
      }
    },
    mounted(){

    },
    props: ['index', 'item', 'cart', 'order', 'isMobile'],
    emits: ['closeCart'],
     methods:{
      increment(index, id) {
        event.stopPropagation();
        axios.post(
  '/api/cart.item.count',
  {id : id, type: 'plus'}
  ).then( response => {
    if(typeof(response.data.success) !== 'undefined'){
      this.cart[index].count++
    }
  })
      },
      decrement(index, id) {
        event.stopPropagation();
        if (this.cart[index].count === 1) {
          this.$bvToast.toast('Меньше нельзя!', {
            title: 'Ошибка',
            variant: 'danger',
            visible: true
          })
        } else {
          axios.post(
  '/api/cart.item.count',
  {'cart': 'shop', id : id, type: 'minus'}
  ).then( response => {
    if(typeof(response.data.success) !== 'undefined'){
      this.cart[index].count--
    }
  })
          
        }
      },
      removeCart(index, id){
        axios.post(
  '/api/cart.remove',
  {'cart': 'shop', id : id}
  ).then( response => {
    if(typeof(response.data.success) !== 'undefined'){
      this.cart.splice(index, 1);
      this.$bvToast.toast(response.data.message, {
            title: 'Оповещение',
            variant: 'success',
            visible: true
          })
    }else{
      this.$bvToast.toast(response.data.message, {
            title: 'Ошибка',
            variant: 'danger',
            visible: true
          })
    }
    
  }).catch( error => {
    this.$bvToast.toast(response.data.message, {
            title: 'Ошибка',
            variant: 'danger',
            visible: true
          })
  })
      },
     }
  }
  </script>
  
  <style scoped>
  </style>